(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble,cart-reminder';

  function rerender(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res.sections) drawer.renderContents(res);
  }

  function changePlan(box, planId, control) {
    var line = parseInt(box.dataset.line, 10);
    var qty = parseInt(box.dataset.quantity, 10) || 1;
    control.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, selling_plan: planId ? String(planId) : null, sections: SECTIONS })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        rerender(res);
      })
      .catch(function (err) {
        console.error('MC2 plan change error:', err);
        control.disabled = false;
      });
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.mc2-plan-select');
    if (!sel) return;
    var box = sel.closest('.mc2-plan');
    if (box) changePlan(box, sel.value || null, sel);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mc2-sub-cta');
    if (!btn) return;
    var box = btn.closest('.mc2-plan');
    if (box) changePlan(box, btn.dataset.planId, btn);
  });

  // Barre collante de la page produit : envoie le plan d'abonnement choisi dans le formulaire
  // (sans plan, le code d'origine de la section ajoute un achat unique).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.custom-pm-sticky__btn');
    if (!btn) return;
    var form = document.querySelector('form.custom-pm__form');
    if (!form) return;
    var fd = new FormData(form);
    var plan = fd.get('selling_plan');
    if (!plan) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: btn.getAttribute('data-variant-id'), quantity: parseInt(fd.get('quantity'), 10) || 1, selling_plan: String(plan) }],
        sections: SECTIONS
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) throw new Error(res.description);
        rerender(res);
      })
      .catch(function (err) { console.error('MC2 sticky add error:', err); })
      .finally(function () {
        btn.textContent = label;
        btn.disabled = false;
      });
  }, true);
})();
